import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const ServiceOrderSelection = (props) => {
  const {
    serviceOrders,
    selectedOrderCode,
    onBack,
    onNext,
    onValueChange,
    selectedServiceOrderId,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the service order you're assigning the turn to</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>This service order also determines the customer selected for this turn. Please note: only orders in a processing state will show up here</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-service=order"
            getOptionLabel={(option) => option.orderCode ?? option}
            options={serviceOrders}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Service Order" />}
            value={selectedOrderCode}
            isOptionEqualToValue={(option, value) => option.orderCode === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedServiceOrderId,
          })}
          disabled={!selectedServiceOrderId}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default ServiceOrderSelection;
